import { ReactNode } from 'react';
import { ArrowLeftIcon } from '../../../Icons/ArrowLeftIcon';
import { Button, IButtonProps } from '../../Buttons/Button';
import { ControlLikeVariant } from '../../variants';

interface IProps extends Omit<IButtonProps, 'size'> {
  variant: ControlLikeVariant;
  children?: ReactNode;
}

export const BackButton = (props: IProps) => {
  const { children, ...rest } = props;
  return (
    <Button aria-label="Back" data-testid="backButton" {...rest}>
      <ArrowLeftIcon />
      {children}
    </Button>
  );
};
